export default __webpack_public_path__ + "static/media/information.6fd71b04.svg";